import React from 'react';
import { ViewContentWrapper } from 'styles/pages/manage-account'
import BasicInfo from './BasicInfo';
import TaxId from './TaxId';
import TaxExemption from './TaxExemption';
import BillTo from './BillTo';
import FeeType from './FeeType';
import FlatFee from './FlatFee';
import PaymentMethod from './PaymentMethod';
import LocationSetUp from './LocationSetUp';
import { Formik } from 'formik';
import { setInitialValues, VALIDATION_SCHEMA } from './viewAndEditUtils'
import { useText } from "locales/useGetText";
function ViewAndEditUserInfo(pageProps) {
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const locale = useText("manageAccount");
  const showTaxExemption = loggedInUserInfo?.locationType !== 'PARENT_LOCATION';
  return (
    <>
      <ViewContentWrapper>
        <Formik
          initialValues={setInitialValues(pageProps.draftData)}
          validationSchema={VALIDATION_SCHEMA}
          onSubmit={(values) => { }}>
          {(props) => {
            const { isValid, dirty, setFieldValue } = props;
            return (
              <>
                <BasicInfo formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} locale={locale} />
                {/* <TaxId formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} /> */}
                {loggedInUserInfo?.locationType !== 'PARENT_LOCATION' && <BillTo formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />}
                {showTaxExemption && <TaxExemption formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />}
                {/* <FeeType formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                                <FlatFee formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                                <PaymentMethod formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                                <LocationSetUp formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} /> */}
              </>
            );
          }}
        </Formik>
      </ViewContentWrapper>
    </>
  )
}
export default ViewAndEditUserInfo
